import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectAuthenticated } from '../features/auth/authSlice';
import { authorizeUser } from '../features/auth/authAsyncThunk';
import { IUserDetails } from '../factory/interfaces';
import { Spin } from 'antd';

interface AuthWrapperProps {
  // Add any additional props you want to pass to the wrapped component
}

const withAuth = <P extends AuthWrapperProps>(
  WrappedComponent: React.ComponentType<P>,
  allowedRoles: string[]
) => {
  const AuthWrapper: React.FC<P> = (props) => {
    const [isLoading, setLoading] = useState(true); // Set initial loading state to true
    const authenticated = useSelector(selectAuthenticated);
    const [userDetails, setUserDetails] = useState<IUserDetails | null>(null);
    const [userRole, setUserRole] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
      setLoading(true); // Start loading
      dispatch(authorizeUser() as any)
        .then((authData: any) => {
          setIsLoggedIn(authData.payload.isLoggedIn);
          setIsAuthenticated(authData.payload.authenticated);
          setUserDetails(authData.payload.userDetails);
          setUserRole(authData.payload.userDetails.role);
        })
        .finally(() => {
          setLoading(false); // End loading
        });
    }, [dispatch]);

    if (isLoading) {
      return <div>

         <Spin size='small'></Spin>
      
      </div>
    }

    if (isAuthenticated && userRole && allowedRoles.includes(userRole)) {
      return <WrappedComponent {...props} />
    } else {
      return <Navigate to="/" />
    }
  }

  return AuthWrapper
}

export default withAuth
